import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import TrackCard from "./TrackCard";
import PlayerModal from "./PlayerModal";

const tracks = [
  {
    title: "Yakamoz",
    year: "2024",
    instrumentation: "2 pianos, 2 percussionists",
    score: "/Gulcelik_Murat_Yakamoz_FinalScore_2024_11_20.pdf",
    sources: [{ src: "/audio/yakamoz.m4a", type: "audio/mp4" }],
  },
  {
    title: "Surveillance",
    year: "2025",
    instrumentation: "Dance composition",
    mediaType: "video",
    youtubeId: "o4Kb1qLNaes",
    sources: [
      { src: "/media/Final_DanceComposition_Video_MuratGulcelik.mp4", type: "video/mp4" },
    ],
  },
  {
    title: "Wait",
    year: "2025",
    instrumentation: "Modular synths",
    sources: [{ src: "/audio/wait.m4a", type: "audio/mp4" }],
  },
  {
    title: "Clarity",
    year: "2024",
    instrumentation: "Soft synths, drones",
    sources: [{ src: "/audio/clarity.m4a", type: "audio/mp4" }],
  },
];

const fadeIn = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] } },
};

export default function Works() {
  const [activeVideoId, setActiveVideoId] = useState(null);
  const [activeAudioId, setActiveAudioId] = useState(null);

  const activeTrack = tracks.find((t) => t.title === activeVideoId) || null;
  const activeVideoTrack =
    activeTrack && activeTrack.mediaType === "video" ? activeTrack : null;

  return (
    <motion.section
      className="max-w-[800px] mx-auto px-6 sm:px-8 py-20 sm:py-28"
      variants={fadeIn}
      initial="initial"
      animate="animate"
    >
      {tracks.map((t) => (
        <TrackCard
          key={t.title}
          {...t}
          activeAudioId={activeAudioId}
          onActivateAudio={setActiveAudioId}
          onOpen={t.mediaType === "video" ? () => setActiveVideoId(t.title) : undefined}
        />
      ))}

      <AnimatePresence>
        {activeVideoTrack ? (
          <PlayerModal
            key={activeVideoTrack.title}
            track={activeVideoTrack}
            onClose={() => setActiveVideoId(null)}
          />
        ) : null}
      </AnimatePresence>
    </motion.section>
  );
}
